import SbuxSelect from "../../../../../../components/SbuxSelect";
import TemporaryMsgAutoCompleteTime from "./TemporaryMsgAutoCompleteTime";
import { getTime } from "../../../../../../utils/timeUtil";
import { Box } from "@mui/material";
import DatePicker from "react-datepicker";
import styles from "../../../styles";
import dayjs from "../../../../../../utils/dayjs";
import { DATE_TIME_BASED_ON_TIMEZONE } from "../../../../../../constants";
import useCss from "../../../../../../hooks/useCss";

const pickerType: Record<number, { name: string }> = {
  1: {
    name: "Start Time",
  },
  2: {
    name: "End Time",
  },
};

interface TemporaryMsgTimePickerProps {
  startDate: Date;
  endDate: Date;
  startTimeValue: string;
  endTimeValue: string;
  timeZoneValue: string;
  timeZoneList: Array<Record<string, unknown>>;
  handleDateChange: (value: { date: Date | null; name: string }) => void;
  handleStartTimeChange?: (value: { time: string; name: string }) => void;
  handleEndTimeChange?: (value: { time: string; name: string }) => void;
  handleTimeZoneChange: (timeZone: string) => void;
  startTimeOption: string;
  endTimeOption: string;
  row: Record<string, unknown>;
  type: number;
}

const TemporaryMsgTimePicker = ({
  startDate,
  endDate,
  startTimeValue,
  endTimeValue,
  timeZoneValue,
  timeZoneList,
  handleDateChange,
  handleStartTimeChange,
  handleEndTimeChange,
  handleTimeZoneChange,
  startTimeOption,
  endTimeOption,
  row,
  type,
}: TemporaryMsgTimePickerProps) => {
  const classes = useCss(styles);
  const typeOfStartTime = type === 1;
  const { name } = pickerType[type];

  return (
    <Box className={classes.timePicker}>
      <Box>
        <DatePicker
          className={classes.datePicker}
          selected={typeOfStartTime ? startDate : endDate}
          minDate={dayjs().toDate()}
          onChange={(date: Date | null) => handleDateChange({ date, name })}
          dateFormat="MM/dd/yyyy"
        />
      </Box>

      <Box>
        <TemporaryMsgAutoCompleteTime
          startTimeOptions={getTime(null)}
          endTimeOptions={getTime(endTimeValue)}
          name={name}
          startDate={startDate}
          endDate={endDate}
          startTimeValue={startTimeValue}
          endTimeValue={endTimeValue}
          startTimeOption={startTimeOption}
          endTimeOption={endTimeOption}
          timeZone={timeZoneValue}
          handleStartTimeChange={(time: string) =>
            handleStartTimeChange?.({ time, name })
          }
          handleEndTimeChange={(time: string) =>
            handleEndTimeChange?.({ time, name })
          }
          row={row}
        />
      </Box>

      {typeOfStartTime ? (
        <>
          <Box className="last">
            <SbuxSelect
              menuItems={
                timeZoneList as import("../../../../../../components/SbuxSelect").MenuItem[]
              }
              defaultValue={timeZoneValue}
              value={timeZoneValue}
              handleSelectChange={(timeZone) => handleTimeZoneChange(timeZone)}
            />
          </Box>
        </>
      ) : (
        <Box className="last bold">
          {`${DATE_TIME_BASED_ON_TIMEZONE} ${dayjs()
            .tz(timeZoneValue)
            .format("MM/DD/YYYY hh:mm a")}`}
        </Box>
      )}
    </Box>
  );
};

export default TemporaryMsgTimePicker;
